import script from "./ExamCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamCategory.vue?vue&type=script&setup=true&lang=ts"

import "./ExamCategory.vue?vue&type=style&index=0&id=c70a6b5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c70a6b5a"]])

export default __exports__